import { initializeApp, type FirebaseApp } from 'firebase/app'
import { getAuth, type Auth } from 'firebase/auth'
import { getFirestore, type Firestore } from 'firebase/firestore'

// Same project as the desktop app — the PWA reads the same library and
// devices documents the desktop app writes. Public web config is not a
// secret; access control is enforced by the firestore.rules deployed
// from the desktop repo (every doc under users/{uid}/ requires the
// authenticated uid to match).
const firebaseConfig = {
  apiKey: 'AIzaSyA-oQbp2JRIw-vdlOe9UNOUi-V9EGXhB7A',
  authDomain: 'govu-c4ee9.firebaseapp.com',
  projectId: 'govu-c4ee9',
  storageBucket: 'govu-c4ee9.firebasestorage.app',
  messagingSenderId: '1027567559632',
  appId: '1:1027567559632:web:2a1df16b8b860451554fd5',
  measurementId: 'G-33237PNDJT',
}

export const firebaseApp: FirebaseApp = initializeApp(firebaseConfig)
export const firebaseAuth: Auth = getAuth(firebaseApp)
export const firestore: Firestore = getFirestore(firebaseApp)
